export function getData(n) {
  const items = getFactorPairs(n);
  return items;
}

function getFactorPairs(n) {
  const pairs = [];

  for (let i = 1; i * i <= n; i++) {
    if (n % i === 0) {
      const pair = `${i} x ${n / i}`; // 👈 formatted here
      pairs.push(pair);
    }
  }

  const final_pairs = filterPairs(pairs);

  return final_pairs;
}

function filterPairs(pairs) {
  const lower = 5;
  const upper = 30;
  return pairs.filter((pair) => {
    const [a, b] = pair.split(" x ").map(Number);

    if (a === 1 || b === 1) return false;
    if (a < lower && b < lower) return false;
    if (a > upper || b > upper) return false;

    return true;
  });
}